export default {
  general: {
    connect: "Connect",
    purchase: "Beställ",
    learn_more: "Läs mer",
    email_address: "E-post",
    password: "Lösenord",
    confirm_password: "Bekräftar lösenord",
    type_password: "Skriv in lösenord",
    placeholder: "Skriv in lösenord",
    forgot_password: "Glömt lösenord",
    login: "Logga in",
    register: "Registrera",
    name: "Namn",
    firstLastName: "För- och efternamn",
    region: "Land",
    select_region: "Välj Land",
    sweden: "Sverige",
    united_kingdom: "UK",
    yes: "Ja",
    no: "Nej",
    continue: "Fortsätt",
    cancel: "Avbryt",
    okay: "Ok",
    accept_terms: "Jag godkänner tjänstevillkoren",
    phone_number: "Telefonnummer",
    send: "Skicka",
    read_more: "Läs mer",
    order_it: "Beställ",
    monthly: "Månatlig",
    annually: "Årligen",
    annual: "Årlig",
    save: "Spara",
    get_plan: "Se prenumeration",
    logout: "Logga ut",
    connect_plus: "Connect Plus",
    status: "Status",
    payment_method: "Betalsätt",
    step: "Steg",
    address: "Adress",
    note: "Anteckning",
    optional: "Frivillig",
    my_home: "Mitt hem",
    is_connected: "Uppkopplad",
    confirm: "Bekräfta",
    additional_info: "Mer information",
    good: "Bra",
    connect_alarm: "Koppla larmsystem",
    not_connected: "Ej uppkopplad",
    change_account: "Byt konto",
    connected: "Uppkopplad",
    connect_account: "Koppla konto",
    ajax_hubId: "Ajax Hub ID",
    na: "Inte tillgänglig",
    home_name: "Namn på hem",
    code_word: "Kodord",
    home_address: "Adress",
    postcode: "Postnummer",
    city: "Postort",
    your_full_name: "För- och efternamn",
    save_and_cont: "Spara och fortsätt",
    next: "Nästa",
    back: "Tillbaka",
    admin: "Admin",
    add: "Lägg till",
    phone: "Telefon",
    email: "E-post",
    burglary: "Inbrott",
    fire: "Brand",
    fight: "Överfallslarm",
    emergency: "Paniklarm",
    sabotage: "Sabotage",
    tech: "Tekniskt fel",
    summary: "Sammanfattning",
    collaborate: "Samverka",
    flood: "Vattenlarm",
    done: "Klart",
    webhook_url: "Webhook URL",
    method: "Metod",
    request_body: "Request Body",
    group: "Grupp",
    groups: "Grupper",
    public: "Publikt",
    locked: "Låst",
    private: "Privat",
    members: "Medlemmar",
    member: "Medlem",
    yes: "Ja",
    edit: "Redigera",
    delete: "Ta bort",
    test: "Test",
    safeland_connect: "Safeland Connect",
    subscription: "Abonnemang",
    service_desc: "Tjänstebeskrivning",
    total_value: "Totalt belopp",
    activation_code: "Aktiveringskod",
    oops: "Hoppsan!",
    activate: "Aktivera",
    new_password: "Nytt lösenord",
    year: "År",
    years: "Års",
    group_name: "Gruppnamn",
    group_type: "Typ",
    undo: "Ångra",
    voluntarily: "Frivilligt",
    yes: "Ja",
    no: "Nej",
    choose: "Välj",
    active: "Aktiv",
    inactive: "Inaktiverad",
    invoice: "faktura",
    reactivate: "Återaktivera",
    ok: "Ok",
    reset_password: "Återställ lösenord",
    ajax_account: "Ajax konto",
    change_hub: "Byt hub",
    select_hub: "Välj hub",
    safelands_phone_number: "Safelands telefonnummer",
    name_and_surname: "Namn och efternamn",
    remove: "Ta bort",
    delete: "Ta bort",
    alarm_triggered: "Larm utlöst",
    alarm_ended: "Larm avslutat",
    system_activated: "System aktiverat",
    system_deactivated: "System inaktiverat",
    night_mode_activated: "Nattläge aktiverat",
    smhi: "Integration med smarta hem",
    test_integration: "Testa integration",
    save_and_close: "Slutför",
    ajax_smhi: "AJAX Smart Home integration",
    new_webhook: "Ny webhook",
    add_new_integration: "Skapa ny integration",
    edit_integration: "Redigera integration",
    non_supported_smhi: "Smart Home integration",
    edit_webhook: "Redigera webhook",
    alarmSMS: "AlarmSMS",
    about_service: "Läs mer om tjänsten",
    add: "Lägg till",
    new_alarm_recipient: "Ny AlarmSMS mottagare",
    edit_alarm_recipient: "Redigera AlarmSMS mottagare",
    showMore: "Visa fler",
    showLess: "Visa färre",
    mobile_number: "Mobilnummer",
    owner: "Ägare",
    no_code_word: "Ingen kodord",
    give_us_feedback: "Ge oss feedback",
    get_started: "Kom igång",
    later: "Senare",
    you: "Du",
    someone_else: "Någon annan",
    alarm_central: "Larmcentral",
    go_back: "Gå tillbaka",
    more_options: "Fler alternativ",
    sms: "sms",
    emergency_alarm: "Akutlarm",
    fire_alarm: "Brandlarm",
    water_alarm: "Vattenlarm",
    burglary_alarm: "Inbrottslarm",
    other: "Annat",
    select: "Välj",
    webhook: "Webhook",
    how_it_works: "Så fungerar det",
    tell_me_more: "Jag vill veta mer",
    your_name: "Ditt namn",
    your_phone_number: "Ditt telefonnummer",
    month: "Månad",
    manage: "Hantera",
    my_closest_circle: "Min närmaste krets",
    other_groups: "Övriga grupper",
    people: "Personar",
    invite_recipients: "Bjud in mottagare",
    person: "Person",
    ajax_systems: "Ajax Systems",
    delete_recepient: "Ta bort mottagare",
    invitation_sent: "Inbjudan skickad",
    step_n_of_n: "Steg {0} av {1}",
    activate_alarmSMS: "Aktivera AlarmSMS",
    update_payment_card: "Uppdatera betalkort",
    upgrade_subscription: "Uppgradera prenumerationen",
    proceed: "Fortsätt",
  },
  htmlHeader: {
    title: "Safelands larmtjänster",
    desc: "Anslut ditt larm till utvalda mottagare eller välj övervakning dygnet runt med en larmcentral med väktare.",
  },
  placeholder: {
    your_email: "Din e-post",
    home_name: "Välj ett namn",
    enter_your_name: "Ange ditt namn",
    enter_home_address: "Lägg till hemaddress",
    webhook_url: "Ange webhook URL",
    request_body: "Ange request body",
    recipients_name: "Ange mottagarens namn",
    recipients_mobile_number: "Ange mottagarens mobilnummer",
    nominees_name: "Kontaktpersonens namn",
    group_name: "Ange gruppnamn",
    phone_number: "+46 000 00 00 00",
    enter_message: "Skriv ditt meddelande här",
    anonymous: "Jag vill vara anonym",
    enter_your_number: "Ange ditt mobilnummer",
    enter_your_phone_number: "Ange ditt mobilnummer",
  },
  feedback: {
    invalid_password: "Lösenord måste innehålla minst 4 tecken",
    invalid_email: "Inte en giltig e-postadress",
    invalid_credentials: "Felaktigt användarnamn eller lösenord",
    invalid_phone: "Ange ett giltigt telefonnummer",
    something_wrong: "Något gick fel",
    forgot_password_success:
      "Vi har skickat ett mail till {0} med instruktioner för hur du ändrar lösenord.",
    unmatched_password: "Lösenorden stämmer inte överens",
    hub_added: "Hub: {0} är nu tillagt till Connect",
    enter_valid_url:
      'Ange en giltig webhook URL, till exempel "https://example.com" eller "http://example.com"',
    enter_valid_JSON: "Lägg till JSON",
    ua_service: "Tjänsten är inte tillgänglig",
    reset_pass_exp_token: "Tyvärr har återställningsnyckeln gått ut.",
    invalid_license_key: "Hoppsan! Felaktig kod. Försök igen.",
    empty_fields: "Fyll i samtliga fält för att fortsätta",
    please_enter_your_value: "Ange din {0}",
    required_name: "Ange ditt namn",
    required_name_and_surname: "Ange ditt namn och efternamn",
    required_email: "Ange din e-post",
    required_phone: "Ange din telefon",
    required_home: "Ange ditt hems namn",
    required_address: "Ange din address",
    required_postcode: "Ange ditt postnummer",
    required_city: "Ange din postort",
    required_recipient_name: "Ange mottagarens namn",
    required_recipient_phone_number: "Ange mottagarens telefonnummer",
    required_nominees_name: "Ange kontaktpersonens namn",
    required_nominees_phone_number: "Ange kontaktpersonens telefonnummer",
    required_nominees_email: "Ange kontaktpersonens e-post",
    recipient_mobile_number_exist:
      "Det finns redan en mottagare med detta mobilnummer",
    phone_already_inuse: "Telefonnumret används redan av ett annat larm.",
    hub_already_inuse:
      "THIS HUB ID IS ALREADY CONNECTED TO SAFELAND. CONTACT SAFELAND IF THIS PERSISTS.",
    required_group_name: "Ange gruppnamn",
    required_country: "Välj en region",
  },
  login: {
    footer: "Ny hos Safeland?",
  },
  register: {
    footer: "Har du redan Safeland-konto?",
  },
  forgot_password: {
    btn: "Skicka länk",
    footer_1: "Logga in",
    footer_2: "Konto Safeland",
  },
  dashboard: {
    card_1_title: "Min Safeland Connect",
    card_1_desc: "Koppla upp eller anpassa din Connect-tjänst",
    card_1_btn: "Logga in",
    card_2_title: "Connect",
    card_2_desc: "Beställ ny Connect - med eller utan larmcentral",
    divider_title: "Connect to Safeland",
    divider_subtitle: "Beställ en av nedan tjänster",
    divider_subtitle_empty: "Din profil har ännu ingen Connect-tjänst",
    login_modal_title: "Logga in på ditt konto i Safeland",
    register_modal_title: "Skapa ett nytt Safeland-konto",
    forgot_password_modal_title: "Återställ lösenord",
    device_notconfig_desc: "Tjänsten är inte komplett eller korrekt uppsatt",
    device_missing_card_desc: "Lägg in betalkort för automatisk förlängning",
    empty_services_title: "Prenumerera på Safelands larmtjänster",
  },
  purchase: {
    title: "Beställ larmtjänster",
    subtitle:
      "Här kan du koppla ditt hemlarm till en eller flera av Safelands larmtjänster.",
    info_1_aside:
      "larm till utvalda mottagare i appen och digital grannsamverkan",
    info_2_aside: "larm till utvalda mottagare via SMS",
    info_3: "Larmcentral med väktare",
    info_4: "Ajax Smart Home integration",
    alarm_conf_para: "Har du redan ett larm som du vill koppla till Safeland?",
    alarm_list_title: "Välj ditt larm",
    success_title: "Välkommen till Safeland",
    success_desc:
      "Tack för din beställning. Nästa steg är att koppla ditt larm till Safeland. Inställningarna går att ändra närsomhelst.",
    alarm_list_footer_title: "Connect alarm using HTTP",
    alarm_list_footer_subtitle:
      "Är ditt hemlarm inte i listan? Det kan gå ändå. Om ditt hemlarm kan trigga en URL med http, så kan du koppla det till Safeland med en webhook.",
    ua_alarm_modal_desc:
      "Den här leverantören är ett slutet larmsystem som inte går att koppla upp till Safeland eller externa system. Vi hjälper dig gärna om du önskar mer modernt hemlarm.",
    plan_modal_title: "Välj alternativ",
    plan_modal_subtitle:
      "Connect är tjänsten med grannar för snabbast åtgärd. Plus ger dig även certifierad larmcentral 24/7 och tillgång till väktartjänst.",
    plan_modal_dec:
      "Larmcentralen från Westra Security hjälper dig om olyckan är framme.",
    alarm_pkg_subtitle: "Beställ ett av Safelands larmpaket",
    alarm_pkg_desc:
      "Prisbelönt hemlarm som du äger själv - utan konstiga villkor",
  },
  service: {
    error_title: "Din tjänst har inte rätt inställningar",
    error_desc:
      "Tjänsten är inte komplett eller korrekt uppsatt. Gå igenom inställningar igen. Kontakta oss om du vill ha hjälp {0}",
    monthly_pay: "Månatlig ({0} {1}/monthly)",
    annually_pay: "Årlig prenumeration ({0} {1}/årligen)",
    card_1_title: "Platsen för ditt larmsystem",
    card_2_title: "Larmsystem",
    card_3_title: "Larmcentral",
    card_5_title: "Min prenumeration",
    card_1_btn: "Redigera plats",
    card_2_btn: "Redigera uppkoppling",
    card_3_btn: "Uppdatera larminstruktion",
    card_4_btn: "Hantera mottagare av larm",
    card_5_btn: "Updatera betalmetod",
    card_5_btn_2: "Avsluta tjänst",
    card_2_footer_sms_title: "Lägg till larmets telefonnummer",
    card_2_footer_sms_desc:
      "Med larmets telefonnummer kan vi identifiera ditt hem och aktivera åtgärd när larmet löser ut.",
    card_2_footer_ajax_title: "Lägg till larmets Hub ID",
    card_2_footer_ajax_desc:
      "HubID använder Safeland för att identifiera ditt larm och för att fånga upp larmmeddelanden.",
    card_4_footer_title: "Har du bjudit in alla?",
    card_4_footer_title_error: "Ställ in mottagare för Connect",
    card_4_footer_desc:
      "Bjud in fler personer till Safeland för ökad samverkan vid larm",
    card_4_footer_desc_error:
      "Skyddet är bäst från personer i närheten. Utan mottagare får du ingen nytta av Safeland-tjänsten.",
    card_4_cont_title: "{0} Personer i {1} Grupper",
    card_4_cont_desc: "tar emot larm från ditt larmsystem",
    unconf_title: "Välkommen till Safeland",
    unconf_desc: "Ställ in dina tjänster i några enkla steg",
    step_alarm_sms_title: "Ställ in AlarmSMS",
    step_smhi_title: "Ställ in Smart Home integration",
    step_location_title: "Ange larmsystemet plats",
    step_alarm_central_title: "Gör instruktioner för larmcentral",
    step_alarm_connection_title: "Koppla larmsystemet till Safeland",
    step_connect_title: "Ställ in Connect",
    edit_loc_title: "Välj eller skapa ditt hem",
    edit_loc_desc: "Välj ett befintligt hem eller lägg till ett nytt hem",
    add_home_item_title: "Lägg till ett nytt hem",
    add_home_item_desc: "Lätt till ett nytt hem på önskad plats",
    add_home_modal_title: "Mitt hem",
    alarm_operator_status_error:
      "Väntar på bekräftelse på uppkoppling av larmcentralen",
    alarm_operator_title: "Kopplad till Westra Security",
    alarm_operator_footer_title: "Lägg till och slutför en larminstruktion",
    alarm_operator_footer_desc:
      "Larmcentralen behöver en aktiv larminstruktion för att agera när larmet löser ut.",
    alarm_connection_unsupported_btn: "Lägg till ett annat larm",
    alarm_connection_unsupported_error_title: "Larm otillgängligt",
    alarm_connection_unsupported_error_desc: "Det här larmet stöds inte längre",
    edit_alarm_connection_title: "Larmtyp",
    edit_alarm_connection_config_modal_title:
      "Koppla ditt larmsystem till Safeland",
    edit_alarm_connection_desc_1:
      "Det är dags att koppla larmet till Safeland!",
    edit_alarm_connection_desc_2: "Bekräftar fabrikat på larm.",
    edit_alarm_connection_btn_1: "Bekräfta och fortsätt",
    edit_alarm_connection_btn_2: "Byt larmtyp",
    edit_alarm_connection_alarms_desc_1:
      "Det är dags att koppla hemlarmet till Safeland Connect",
    edit_alarm_connection_alarms_desc_2: "Välj fabrikat på hemlarm",
    edit_alarm_connection_ajax_desc_1: "Har du bytt Ajax hub?",
    edit_alarm_connection_ajax_desc:
      "Välj hubben - valet ersätter tidigare hub.",
    edit_alarm_connection_ajax_login_desc: "Inloggad hos Ajax som: {0}",
    edit_alarm_connection_ajax_login_title:
      "Logga in på ditt Ajax-konto för att koppla en hub till Safeland",
    edit_alarm_connection_modal_title: "Koppla ditt larmsystem till Safeland",
    edit_alarm_connection_login_desc:
      "Logga in på ditt Ajax-konto för att koppla en hub till Safeland",
    edit_alarm_connection_hubs_desc:
      "Välj hubben - valet ersätter tidigare hub",
    edit_payment_info_del_title: "Säg upp tjänst?",
    edit_payment_info_del_desc:
      "Är du säker på att du vill avsluta tjänsten? Tjänsten är aktiv till dess att din förbetalda period tar slut {0}.",
    edit_payment_info_del_btn: "Ja, jag vill säga upp tjänsten",
    payment_info_modal_title: "Registrera nytt betalkort",
    payment_info_canceled_desc:
      "Du har nu avslutat din prenumeration. Om du skulle ångra dig går det bra genom att kontakta Safelands support.",
    payment_info_canceled_footer_title: "Prenumerationen uppsagd",
    payment_info_canceled_footer_desc: "Tjänsten är aktiv till {0}",
    payment_activate_footer:
      "Viktigt! Du behöver lägga in kortuppgifter för att förhindra att din tjänst avslutas vid slutet av prenumerationsperioden. Beloppet debiteras vid ny period.",
    payment_invoice_title: "Fakturakund",
    payment_invoice_desc:
      "Kontakta {0} för att att hantera uppgifter eller avsluta prenumeration.",
    payment_desc_cancelled_title: "Prenumerationen uppsagd",
    payment_desc_cancelled_subtitle: "Tjänsten är aktiv till",
    payment_cancelled_title: "Betald t.o.m.",
    payment_cancelled_missing_card_subtitle:
      "Lägg in betalkort för att fortsätta tjänsten efter avslutsdatum",
    payment_btn_0_missing_card: "Lägg in betalkort",
    payment_btn_0: "Uppdatera betalkort",
    payment_btn_1: "Avsluta nu",
    payment_btn_2: "Avsluta på förfallodatumet",
    payment_btn_3: "Uppgradera prenumerationen",
    payment_modal_add_card_missing_card_title: "Registrera nytt betalkort",
    payment_modal_add_card_title: "Uppdatera betalkort",
    payment_modal_cancelled_title: "Avsluta prenumerationen?",
    payment_modal_cancelled_subtitle:
      "Är du säker på att du vill avsluta prenumerationen?",
    payment_add_card_desc:
      "Kontakta {0} om du föredrar att betala med årlig faktura med bankgiro",
    payment_modal_manage_title: "Hantera prenumerationen",
    smhi_webhooks_desc:
      "Här kan du aktivera, inaktivera och konfigurera externa webhooks.",
    smhi_webhook_empty_desc:
      "Safeland kan anropa ett externt system med en webhook när ditt larmsystem löser ut.",
    smhi_webhook_desc: "Safeland anropar denna webhook vid utlöst larm.",
    alarmSMS_desc: "Snabb hjälp från de du litar på – enkelt och effektivt.",
    alarmSMS_modal_del_title: "Ta bort AlarmSMS mottagare",
    alarmSMS_modal_del_desc: "Är du säker på att du vill ta bort {0}?",
    alarmSMS_inactive_subtitle:
      "Erbjudande - utan kostnad för dig med Safeland Connect",
    alarmSMS_inactive_info_title:
      "Hjälp när varje sekund räknas - snabbt och utan krångel",
    alarmSMS_inactive_info_desc:
      "AlarmSMS är en larmtjänst som skickar larmnotiser via SMS till dina valda mottagare. De får en webblänk, där de kan samarbeta och hålla sig uppdaterade i realtid - ingen app behövs.",
    alarmSMS_inactive_info_subtitle_0: "{0} SMS per månad ingår.",
    alarmSMS_intro_title: "Safeland lanserar AlarmSMS",
    alarmSMS_intro_terms_desc: "Jag har läst och godkänner {0} för AlarmSMS",
    alarmSMS_intro_terms_text: "villkoren",
    alarmSMS_term_title: "Särskilda villkor för AlarmSMS",
    alarmSMS_term_cond_0_title: "Tjänstebeskrivning",
    alarmSMS_term_cond_0_subtitle:
      "Tjänsten AlarmSMS innebär att SMS-meddelanden sänds till de telefonnummer som kunden anvisar, i enlighet med den aktuella tjänstebeskrivningen som beskrivs på Safelands webbplats.",
    alarmSMS_term_cond_1_title: "Inkluderade meddelanden och tillägg",
    alarmSMS_term_cond_1_subtitle:
      "I tjänsten ingår trettio (30) SMS-meddelanden per kalendermånad. Om det i en enskild kalendermånad förbrukas samtliga ingående SMS-meddelanden, debiteras kunden med fyrtionio (49) kronor, vilket medför ytterligare trettio (30) SMS-meddelanden. Inga SMS-meddelanden sparas till efterföljande månad.",
    alarmSMS_term_cond_2_title: "Ansvar och godkännande",
    alarmSMS_term_cond_2_subtitle:
      "Kunden ansvarar för att angivna telefonnummer är korrekta samt att varje mottagare har lämnat det nödvändiga godkännandet för mottagande av SMS-meddelanden. Mottagaren kan på eget initiativ avsluta mottagandet av ytterligare SMS; i sådant fall skickas inga nya SMS-meddelanden till dennes telefonnummer.",
    alarmSMS_term_cond_3_title: "Avaktivering av tjänsten",
    alarmSMS_term_cond_3_subtitle:
      "Om du inte vill att du eller dina mottagare ska få AlarmSMS behöver du tömma mottagarlistan.",
    alarmSMS_term_cond_4_title: "Övriga villkor",
    alarmSMS_term_cond_4_subtitle:
      "Tjänsten AlarmSMS ingår för närvarande tillfälligt i tjänsten Safeland Connect. Safeland åtar sig inget ansvar med avseende på prissättning eller leveransvillkor vid en eventuell förnyelse av tjänsten. Safelands allmänna villkor finns tillgängliga på www.safeland.se/se/villkor.",
    alarmSMS_steps_title: "Aktivera AlarmSMS - Steg {0} av 2",
    alarmSMS_steps_1_1_desc: "Vill du lägga till dig själv som mottagare?",
    alarmSMS_steps_1_2_desc:
      "Lägg till fler mottagare (du kan ändra listan senare).",
    alarmSMS_options_total_desc: "har skickats denna månad",
    alarmSMS_options_categories_title:
      "Välj de larmtyper som ska skickas till dina mottagare",
    connect_inactive_subtitle: "Snabb hjälp från de du litar mest på",
    connect_inactive_desc:
      "Connect kopplar ditt larmsystem till din digitala grannsamverkan. Anslut larmsystemet till din samverkansgrupp i Safeland-appen och få snabbast  hjälp från personer som du litar på.",
    alarm_central_inactive_subtitle:
      "Trygghet dygnet runt med professionell hantering",
    alarm_central_inactive_desc:
      "Larmcentralen finns där dygnet runt, vilket ger en trygghet när du är på jobbet, på  semester eller sover. Du behöver inte vara tillgänglig eller reagera själv. ",
  },
  add_home: {
    desc: "Bekräfta adress och ge även hemmet ett namn.",
    placeholder_1: "t.ex. hemma, sommarstugan",
    placeholder_2: "Sök och välj adressen",
    error_msg_2:
      "Adressen är inte komplett. Sök fram och välj full adress i listan",
    placeholder_3:
      "Lägg till information som kan vara bra för larmmottagare i Safeland vid larm, t.ex. gula huset, eller dörrkod",
    add_info_placeholder: "Gula huset, ingång till högra dörren med kod 1739",
  },
  service_verisure: {
    desc: "Koppla upp Verisure i två enkla steg. Börja med att logga in på Verisure Mina Sidor på webben.",
    step_1: "Lägg till Safelands telefonnummer som mottagare av larm",
    step_1_1:
      "Lägg till Safeland som mottagare av SMS för Brand och/eller Inbrott: {0}",
    step_1_2: "Köp SMS på Mina Sidor",
    step_2: "Lägg till din unika identifierare",
    step_2_1:
      "Använd koden för att namnge ditt Verisure larmsystem. Klicka på koden för att kopiera den.",
  },
  service_webhook: {
    desc_1:
      "Här är en unik webhook för ditt hemlarm. När ditt larm löser ut kommer denna anropa denna webhook som ett HTTP POST förfrågan. Tryck på webhooken för att kopiera den.",
    desc_2:
      "Här är en unik webhook för ditt hemlarm. När ditt larm löser ut kommer denna anropa denna webhook som ett HTTP POST förfrågan.",
  },
  service_edit_phone: {
    title: "Lägg till Safelands telefonnummer i inställningarna för ditt larm",
    desc_1:
      "När larmet löser ut skickas ett SMS till en lista på telefonnummer. Det är på det sättet som Safeland tar emot ditt larm. Följ din hemlarms instruktion och lägg till Safeland som en mottagare.",
    desc_2:
      "Följ din hemlarms instruktion och lägg till Safeland som en mottagare. Vårt nummer är:",
    condition: "Jag har lagt till Safeland som larmmottagare",
    number_modal_title: "Telefonnummer alarm",
    number_modal_desc:
      "Telefonnummer till ditt hemlarm. Detta är så att Safeland kan identifiera ditt hem och att det tillhör dig.",
  },
  service_edit_alarm_operator: {
    summary: "Sammanfattning",
    step1_title: "Personlig information",
    step1_desc:
      "Fyll i informationen nedan. Informationen delas med larmcentralen. Kodord är frivilligt och kommer att efterfrågas av larmoperatören om den är ifylld.",
    contacts_title: "Mottagare genom samtal vid larm",
    contacts_desc:
      "Utse personer som blir uppringda av larmcentralen när ditt larm löser ut. Kodord är frivilligt men kommer efterfrågas av larmoperatören vid larm om det är ifyllt.",
    contacts_form_title: "Lägg till kontaktpersoner",
    contacts_form_desc: "Fyll i formuläret och klicka ’Lägg till’",
    contacts_admin_desc:
      "Larmmottagaren har full befogenhet vid larm samt att ändra larminstruktionen, exempelvis tillkalla väktare.",
    contacts_table_title: "Kontaktpersoner telefonlista",
    contacts_del_modal_title: "Ta bort kontaktperson",
    actions_title: "Välj de larmtyper som ska skickas till dina mottagare",
    actions_desc_1: "Du beslutar larmoperatörens åtgärder för olika larmtyper.",
    actions_desc_2:
      "Notera: Vid larmutryckning utgår normalt en kostnad vid väktarutryckning. Se tjänstens villkor för debitering.",
    actions_option_1: "Ingen åtgärd",
    actions_option_2: "Skicka alltid väktare direkt",
    actions_option_3:
      "Kontakta kontaktpersoner dagtid, vid uteblivet svar och övrig tid väktare för kontroll.",
    actions_option_4:
      "Kontakta kontaktpersoner dygnet runt, vid uteblivet svar väktare för kontroll",
    actions_option_5:
      "Kontakta kontaktpersoner dygnet runt, inga mer åtgärder.",
    summary_detail_1_title: "Larmcentral och Safelandappen",
    summary_detail_1_desc:
      "Larmcentralen kan inte ta del av dina grannars samverkanskommunikation i Safeland-appen.",
    summary_detail_2_title: "Kostad för väktarutryckning",
    summary_detail_2_desc:
      "Vid nyttjande av väktartjänster i linje med anvisningarna i ovan åtgärdsplan tillkommer en avgift enligt tjänstens aktuella villkor. Faktura skickas till angiven e-postadress med 20 dagars betalningsvillkor. Avgift för väktartjänster utgår inte vid skarpa inbrottsförsök i privathushåll. Styrkande av inbrottsförsök sker genom att mail med kopia av polisanmälan. Vid aktivering av Larmcentral-tjänsten för företag utgår en extra årlig avgift på 25%, vilken faktureras separat.",
    summary_detail_3_title: "Hantering av information och generella villkor",
    summary_detail_3_desc:
      "Tjänsten innebär att Safeland och leverantören Westra Security AB har tillgång till personlig information. Denna information består av ovan uppgifter samt den information som genereras av Safeland-tjänsten och hemlarmet. Informationen är nödvändig för att leverera tjänsten till dig som kund.",
  },
  service_edit_collaborators: {
    desc: "Välj de som ska ta emot dina larm. Det kan vara grannar, vänner, familj eller andra du litar på.",
    count_desc_1: "Just nu har du",
    count_desc_2: "som kan ta emot dina larm",
    invite_title_placeholder: "{0}s hemlarm",
    invite_desc:
      "De viktigaste personerna som ska ta emot larm från larmsystemet.",
    invite_btn: "Bjud in fler",
    invite_btn_2: "Skapa en ny grupp",
    invite_footer: "Väntar på svar från {0} inbjudningar",
    invite_footer_placeholder: "Ännu ingen inbjuden till gruppen",
    group_title: "Koppla till grupper i Safeland",
    group_empty_desc_1:
      "Safeland används av många lokala trygghetsgrupper som samverkar för en säkrare och trivsammare tillvaro. Saknar du lämplig grupp att samverka med så rekommenderar vi att du startar med 3-5 grannar. Det är ofta någon hemma och ni kan alla hjälpa varandra i chatten",
    group_empty_desc_2:
      "Om du är medlem i en grupp, så kan du även koppla ditt larm till gruppen. Efter att du har slutfört inställningarna här, ta gärna en titt på vilka grupper som finns i ditt område!",
    group_desc:
      "Välj att ansluta ditt larm till fler grupper som du är medlem i, t.ex den lokala grannsamverkansgruppen.",
    group_btn: "Välj grupper",
    group_footer:
      "Tips: du kan hitta och gå med i befintliga grupper i Safeland-appen",
    actions_desc:
      "Välj de larmtyper som du vill skall skickas ut till ovan valda grupper i Safeland",
    hook_title: "Smart Home Integration (Beta)",
    hook_desc: "Safeland kan anropa en extern webhook när ditt larm löser ut.",
    hook_btn: "Anpassa webhook",
    invite_modal_title: "Bjud in med e-post",
    invite_modal_desc:
      "Bjud in personer till att bli larmmottagare när ditt larm går.",
    invite_modal_input_label:
      "Skriv en eller flera mailadresser i fältet (Separera dem med mellanslag eller enter).",
    invite_modal_input_placeholder: "Skriv en eller flera e-postadresser",
    invite_modal_btn: "Bjud in",
    group_modal_title: "Koppla till existerande Safeland-grupper",
    group_modal_desc:
      "Anslut ditt larm till fler grupper som du är medlem i, t.ex den lokala grannsamverkansgruppen.",
    webhook_modal_title: "Anropa en extern webhook",
    webhook_modal_desc:
      "Safeland kan anropa en extern webhook när ditt larm löser ut. Ange informationen i formuläret nedan för att konfigurera webhook-requesten.",
    webhook_del_title: "Ta bort webhook",
    webhook_del_desc: "Är du säker på att du vill ta bort webhook?",
    webhook_test_title: "Testa min webhook",
    webhook_test_desc:
      "Tryck på knappen Skicka för att skicka ett testanrop till din webhook",
    new_group_modal_title: "Skapa Grupp",
  },
  not_found: {
    title: "404",
    desc: "Sidan finns inte",
  },
  activate: {
    header_title: "Aktivera tjänsten",
    footer_desc: "Tjänsten är redan aktiverad!",
    unauth_title: "Aktivera",
    unauth_desc:
      "Kom igång genom att skapa ett nytt konto på Safeland eller logga in på ditt befintliga.",
    error: "Något har blivit fel, kontakta {0} om problemet kvarstår",
    success_title: "Bravo! Tjänsten är nu aktiverad.",
    success_desc:
      "Din tjänst är aktiverad. Nu återstår kopplingen av ditt larmsystem till Safeland för ett tryggare hem.",
    success_btn: "Genomför inställningarna",
    invalid_title: "Skriv in din aktiveringskod",
    invalid_desc:
      "Skriv in din unika aktiveringskod nedan för att aktivera din tjänst.",
  },
  reset_password: {
    title: "Välj ett nytt lösenord",
    desc: "Snart klar! Skriv in ditt nya lösenord nedan för att återställa lösenordet",
    btn: "Uppdatera mitt lösenord",
    invalid_link_title: "Felaktig återställningslänk",
    invalid_link_desc:
      "Åh nej! Det verkar som att din återställningslänk inte är giltig längre.",
    success_feedback: "Lösenordet har uppdaterats för {0}.",
  },
  authentication: {
    title: "Safelands larmtjänster",
    info_0_title: "Connect",
    info_0_desc: "Larm till utvalda mottagare och digital samverkan",
    info_1_title: "Larmcentral med väktare",
    info_1_desc: "Övervakning dygnet runt med professionell hantering",
    info_2_title: "AlarmSMS",
    info_2_desc: "Larm till utvalda mottagare via SMS",
    info_3_title: "Smart Home integration",
    info_3_desc: "Integrera larmet med ditt smarta hem",
  },
  feedback_page: {
    title: "Ge oss feedback",
    desc_0: "Finns det något vi kan göra bättre? Saknas det något?",
    desc_1:
      "Dela gärna dina tankar med oss så vi kan göra tjänsten ännu bättre!",
    success_title: "Tack för din åsikt!",
    success_desc:
      "Vi jobbar ständigt för att förbättra våra tjänster och är tacksamma för att du tagit dig tiden att göra din röst hörd.",
  },
  unsupported_device: {
    default_title: "För dig med valt larm",
    default_description:
      "Tyvärr går det inte att använda valt Alarm för Safelands larmtjänster.",
    info: "Om du funderar på att avsluta ditt abonnemang – passa på att utvärdera Safelands egna hemlarm. Du får ett {0}, {1} du äger själv, med {2} och {3}.",
    info_highligh_0: "lättanvänt",
    info_highligh_1: "högteknologiskt system",
    info_highligh_2: " lägre kostnad",
    info_highligh_3: "smarta larmtjänster",
    btn_0: "Till hemlarm",
    contact_modal_title: "Vill du veta mer?",
    contact_desc:
      "Lämna ditt telefonnummer så ringer vi upp och berättar mer om vårt erbjudande.",
  },
  configure_device: {
    http_title: "Larm med anslutning via HTTP",
    http_description:
      "Det går att ansluta alla larm som har stöd för webhooks, till exempel:",
    http_description_ex_0: "Nest Protect",
    http_description_ex_1: "Minut Point",
    sms_title: "Larm med anslutning via SMS",
    sms_description:
      "Det går att koppla upp alla larm som har stöd för anslutning via SMS.",
    other_subheading: "Finns ditt larm inte med i listan?",
    other_description: "Kontakta oss om du vill modifiera larmuppkoppling.",
  },
  subscription_plans: {
    title: "Välj ett paket",
    proration_ok_text: "Betala {0} kr nu",
    proration_desc_0:
      "Din nuvarande prenumeration kommer att avslutas och du kommer att återbetalas {0} kr.",
    proration_desc_1:
      "Därefter börjar din prenumeration på {0} och du kommer att debiteras {1} kr.",
    payment_failed_desc:
      "Betalning misslyckades. Vänligen uppdatera ditt betalkort.",
    upgrade_successful_desc:
      "Grattis! Din prenumeration har uppgraderats till {0}.",
  },
  api: {
    services: {
      devices: {
        terms:
          "Grattis! Det går att koppla Verisure larm till Safeland. Du behöver inte ha abonnemang hos Verisure..\n\n Safeland Connects ger dig snabb åtgärd tillsammans med vänner och grannar. Connect Plus ger dig även larmcentralstjänsten som arbetar för dig 24/7.",
      },
      devicePackages: {
        premiumlarmet_title: "Safelands populära hemlarm",
        premiumlarmet_btn_0: "Läs mer och beställ",
        folklarmet_desc:
          "An impressive home alarm kit that doesn’t cost the earth. The Sikkerthjem S6evo is great value for money and contains all the fundamental components that a modern home alarm system needs.",
        premiumlarmet_desc:
          "Det säkra kortet för dig som vill ha ett mycket bra hemlarm – oavsett boendeform.",
      },
      paymentPlans: {
        basic_infos: ["Connect", "AlarmSMS", "Smart Home integration"],
        plus_infos: [
          "Connect",
          "AlarmSMS",
          "Smart Home integration",
          "Certifierad larmcentral 24/7",
          "Tillgång till väktartjänst",
        ],
      },
    },
  },
};
